import number from '@/helpers/number';
import classNames from 'classnames';

const CardDataDetailItem = ({ title, content }) => {
    return (
        <div className="flex justify-between">
            <h4 className="text-left text-sm">{title}</h4>
            <h4 className="text-right text-sm">{content}</h4>
        </div>
    )
}

const Card = ({
    company_name,
    contact_full_name,
    telephone,
    rut,
    email,
    ticket_quantity,
    ticket_price,
    total_price
}) => {
    return (
        <div className="h-full bg-white rounded-xl w-full px-4 py-8 col-span-3 lg:col-span-1">
            <h2
                className={classNames("text-center text-3xl", {
                    "text-gray-400": !company_name
                })}
            >
                {company_name || 'Razón social'}
            </h2>
            <h4 className={classNames("text-center text-lg mb-8", {
                "text-gray-400": !contact_full_name
            })}>
                {contact_full_name || 'Nombre y apellido del contacto empresa'}
            </h4>

            <div>
                {[
                    {
                        title: "Número de teléfono",
                        content: telephone,
                    },
                    {
                        title: "R.U.T",
                        content: rut,
                    },
                    {
                        title: "Correo Electrónico",
                        content: email,
                    },
                ].map((data, index) => (
                    <CardDataDetailItem
                        key={`card-info-data-item-${index}`}
                        {...data}
                    />
                ))}
            </div>

            <div>
                {[
                    {
                        title: "Cantidad de tickets",
                        content: number.format(ticket_quantity),
                    },
                    {
                        title: "Precio por ticket",
                        content: "$" + number.format(ticket_price),
                    },
                    {
                        title: "Total",
                        content: "$" + (total_price ? number.format(total_price) : 0),
                    },
                ].map((data, index) => (
                    <CardDataDetailItem
                        key={`card-price-data-item-${index}`}
                        {...data}
                    />
                ))}
            </div>
        </div>
    );
};

export default Card;
